export const CONTENT_TRAINING = {
  LIST: 'CONTENT_TRAINING_LIST',
  LIST_DONE: 'CONTENT_TRAINING_LIST_DONE',
  LIST_FAILED: 'CONTENT_TRAINING_LIST_FAILED',
  LOAD: 'CONTENT_TRAINING_LOAD',
  LOAD_DONE: 'CONTENT_TRAINING_LOAD_DONE',
  LOAD_FAILED: 'CONTENT_TRAINING_LOAD_FAILED',
};

export const loadContentsTraining = (id, params) => ({ type: CONTENT_TRAINING.LIST, id, params });

export const loadContentTraining = id => ({ type: CONTENT_TRAINING.LOAD, id });



// WEBPACK FOOTER //
// ./src/actions/contentsTraining.js